
import './App.css';
import {Route, BrowserRouter, Routes} from 'react-router-dom'

import Home from './pages/Home';
import Cart from './pages/Cart';
import Product from './pages/Product';
import DashboardLayout from './layout/DashbaordLayout';
import Receipt from './pages/Receipt';
import UploadItem from './pages/UploadItem';
import Payment from './pages/Payment';
import Chat from './pages/Chat';
import ViewStats from './pages/ViewStats';

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route element={<DashboardLayout/>}>
             <Route path="/" element={<Home/>}/>
             <Route path="/cart" element={<Cart/>}/>
             <Route path="/product/:id" element={<Product/>}/>
             <Route path="/receipt" element={<Receipt/>}/>
             <Route path="/upload" element={<UploadItem/>}/>
             <Route path="/payment" element={<Payment/>}/>
             <Route path="/chat" element={<Chat/>}/>
             <Route path="/viewStats" element={<ViewStats/>} />
          </Route>
        </Routes>
    </BrowserRouter>
  );
}

export default App;
